<template>
  <div class="base noselect">
    <Menu />
    <div class="vertical-center">
      <p class="magic-hover">in development.</p>
    </div>
  </div>
</template>

<script>
import Menu from "./Menu";

export default {
  name: "Base",
  components: {
    Menu,
  },
};
</script>

<style>
@import "../assets/css/base.css";
@import "../assets/css/magic_mouse.css";
</style>
